export const PROJECT_NUMBER_CONFIRMATION_CONSTANT = {
  // csvファイル名
  CSV_FILENAME: 'projectNumber',
};
